/* BASE FRAMEWORK */
'use strict';

const html = document.querySelector('html');

/*
INDEX OF FUNCTIONS

RESPONSIVE FUNCTIONS
viewport()                       - Get the current viewport
device()                         - Get the device type
touchEnabled()                   - Boolean; checks if the device is touchenabled or not
desktopZoomed()                  - Desktop view zoomed correctly on iPad

SUPPORTING FUNCTIONS
detectImages()                   - Boolean; Returns true or false for when images are disabled in the browser

COOKIE FUNCTIONS
setCookie()
getCookie()
eraseCookie()
*/


// IE8 polyfill
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (obj, start) {
        for (var i = (start || 0), j = this.length; i < j; i++) {
            if (this[i] === obj) {
                return i;
            }
        }
        return -1;
    };
}

// ie11 polyfill
if (!Array.from) {
  Array.from = (function () {
    var toStr = Object.prototype.toString;
    var isCallable = function (fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function (value) {
      var number = Number(value);
      if (isNaN(number)) { return 0; }
      if (number === 0 || !isFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function (value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike/*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError('Array.from requires an array-like object - not null or undefined');
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method 
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }());
}

function classRemove(element, classes) {
    classes.forEach(function (clas) {
        element.classList.remove(clas);
    });
}

window.cookieValue;

/* RESPONSIVE FUNCTIONS */

/* VIEWPORT */
export function viewport() {
    var width = document.body.clientWidth,
        viewport = 'default';

    if (width >= 1344) {
        viewport = 'desktop-wide';
    }
    if (width < 1344) {
        viewport = 'desktop-compact';
    }
    if (width < 1024) {
        viewport = 'tablet-portrait';
    }
    if (width < 768) {
        viewport = 'mobile-landscape';
    }
    if (width < 481) {
        viewport = 'mobile-portrait';
    }

    classRemove(html, ['default', 'desktop-compact', 'tablet-portrait', 'mobile-landscape', 'mobile-portrait']);
    html.classList.add(viewport);

    return viewport;
}


/* DEVICE*/
export function device() {
    var device = 'desktop';
    switch (viewport()) {
        case 'desktop-compact':
            device = 'desktop';
            if (touchEnabled()) {
                device = 'tablet';
            }
            break;
        case 'tablet-portrait':
            device = 'tablet';
            break;
        case 'mobile-landscape':
        case 'mobile-portrait':
            device = 'mobile';
            break;
    }
    classRemove(html, ['mobile', 'tablet', 'tablet-portrait', 'desktop']);
    html.classList.add(device);

    return device;
}

/* TOUCH ENABLED */
export function touchEnabled() {
    if ('ontouchstart' in window || 'onmsgesturechange' in window) {
        html.classList.add('touchenabled');
        return true;
    }
    html.classList.remove('touchenabled');
    return false;
}

/* DESKTOP ZOOMED IN IPAD */
/***** DETECT IF USING iOS5 THEN FIX ORIENTATION BUG *****/
export function desktopZoomed() {
    var viewportmeta = document.querySelector('meta[name=viewport]');
    if (navigator.userAgent.match(/iPad/i) || (window.outerWidth > 768 && window.outerWidth < 1024)) {
        viewportmeta.content = 'width=1024';
    } else if (window.outerWidth <= 480) {
        viewportmeta.content = 'width=device-width, initial-scale=1, user-scalable=no';
    }
}



/* SUPPORTING FUNCTIONS */

/* DETECTION */
/***** IMAGES ON / OFF **********/

export function detectImages() {
    var timestamp = new Date().getTime(),
        image = new Image();

    html.classList.add('images-off');
    image.onload = function () {
        if (image.width > 0) {
            html.classList.remove('images-off');
        }
    };
    image.src = '/assets/img/blank.png?timestamp=' + timestamp;
}




/* COOKIE FUNCTIONS */
/* Set cookie information */
export function setCookie(c_name, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = encodeURIComponent(value) + ((exdays === null) ? '' : ';path=/; expires=' + exdate.toUTCString());
    document.cookie = c_name + '=' + c_value;
}

/* get cookie information */
/*jshint unused: true */
/*exported getCookie */
export function getCookie(c_name) {
    var i, getCookieName, getCookieValue, cookieData = document.cookie.split(';');
    for (i = 0; i < cookieData.length; i += 1) {
        getCookieName = cookieData[i].substr(0, cookieData[i].indexOf('='));
        getCookieValue = cookieData[i].substr(cookieData[i].indexOf('=') + 1);
        getCookieName = getCookieName.replace(/^\s+|\s+$/g, '');
        if (getCookieName === c_name) {
            window.cookieValue = getCookieValue;
            return decodeURIComponent(getCookieValue);
        }
    }
}

/* delete cookie information */
/*jshint unused: true */
/*exported eraseCookie */
export function eraseCookie(c_name) {
    window.setCookie(c_name, '', -1);
}


/* INITIALISERS */

/* IMMEDIATE */
detectImages();
device();
viewport();
touchEnabled();
//desktopZoomed();

window.addEventListener('resize', function () {
    device();
    viewport();
});
